import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BaseQuestionComponent } from '../base-question.component';

/**
 * Confirmation question: one checkbox the applicant ticks to confirm a
 * statement — a declaration, like "I confirm I hold a valid passport".
 *
 * Distinct from a checkbox list, which offers a choice between options. There
 * is nothing to choose here: the statement is the label, and the answer is
 * whether it was ticked.
 */
@Component({
  selector: 'app-confirmation-question',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './confirmation-question.component.html',
  styleUrl: './confirmation-question.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmationQuestionComponent extends BaseQuestionComponent {
  /** The statement being confirmed; the question's label carries it. */
  onStatementChange(value: string): void {
    this.updateLabel(value);
  }

  onHelperTextChange(value: string): void {
    this.updateHelperText(value);
  }

  onAdditionalInfoChange(value: string): void {
    this.updateAdditionalInfo(value);
  }

  onRequiredToggle(): void {
    this.updateRequired(!this.question().isRequired);
  }
}
